module.exports = __webpack_public_path__ + "img/homepage-content-image-kia.53c53d19.jpg";